import {
  GET_RUN_REQUEST,
  GET_RUN_SUCCESS,
  GET_RUN_FAILURE
} from '../../../actions/api/run';
import { TASK_DETAILS_INITIALIZE } from '../../../actions/page/tasks/TaskDetails';

export default function TaskDetails(state = {}, action) {
  switch (action.type) {
    case TASK_DETAILS_INITIALIZE:
      const defaults = {
        loading: true,
        error: false,
        errorMessage: ''
      };
      return {
        ...state,
        ...defaults
      };
    case GET_RUN_REQUEST:
      return {
        ...state,
        error: false,
        errorMessage: ''
      };
    case GET_RUN_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case GET_RUN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/tasks/TaskDetails.js